import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import LinkButton from 'flarum/common/components/LinkButton';
import Link from 'flarum/common/components/Link';
import Modal from 'flarum/common/components/Modal';
import Alert from 'flarum/common/components/Alert';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import { t, text, statuses, date, money, vehicle, fileSize, orderUrl, canManage } from '../helpers';
import BsiIcon, { buttonIcon, pageIcons } from './BsiIcon';
export class MobileTitle extends Component {
  view() {
    return m("div", {
      className: "App-titleControl BsiMobileTitle"
    }, m(LinkButton, {
      className: "Button",
      href: app.route('index')
    }, m("span", {
      className: "BsiBrandMark",
      "aria-hidden": "true"
    }), "BSI.by"));
  }
}
export class Status extends Component {
  view() {
    return m("span", {
      className: 'BsiStatus BsiStatus--' + this.attrs.status
    }, t('status.' + this.attrs.status));
  }
}
export class ErrorBox extends Component {
  view() {
    return this.attrs.error ? m(Alert, {
      type: "error",
      dismissible: false
    }, this.attrs.error) : null;
  }
}
export class PageHeading extends Component {
  view(vnode) {
    return m("div", {
      className: "BsiHeading"
    }, m("div", {
      className: "BsiHeading-main"
    }, this.attrs.icon && m("span", {
      className: "BsiHeading-icon"
    }, m(BsiIcon, {
      name: this.attrs.icon
    })), m("div", null, m("h1", null, this.attrs.title), this.attrs.description && m("p", {
      className: "helpText"
    }, this.attrs.description))), m("div", {
      className: "BsiHeading-actions"
    }, vnode.children));
  }
}
export class AuthRequired extends Component {
  view() {
    return m("div", {
      className: "BsiEmpty"
    }, m("span", {
      className: "BsiEmpty-icon"
    }, m(BsiIcon, {
      name: "lock-key"
    })), m("h1", null, t('auth.title')), m("p", null, t('auth.message')), m("div", {
      className: "BsiActions"
    }, m(Button, {
      className: "Button Button--primary",
      icon: buttonIcon('sign-in'),
      onclick: () => app.modal.show(() => flarum.reg.asyncModuleImport('flarum/forum/components/LogInModal'))
    }, t('auth.login')), m(Button, {
      className: "Button",
      icon: buttonIcon('user-plus'),
      onclick: () => app.modal.show(() => flarum.reg.asyncModuleImport('flarum/forum/components/SignUpModal'))
    }, t('auth.signup'))));
  }
}
export class OrderCards extends Component {
  view() {
    const orders = this.attrs.orders;
    if (!orders.length) return m("div", {
      className: "BsiEmpty"
    }, m("span", {
      className: "BsiEmpty-icon"
    }, m(BsiIcon, {
      name: "folders"
    })), m("h2", null, t(this.attrs.admin ? 'orders.admin_empty' : 'orders.empty')), m("p", null, t(this.attrs.admin ? 'orders.admin_empty_help' : 'orders.empty_help')), !this.attrs.admin && m(LinkButton, {
      className: "Button Button--primary",
      icon: buttonIcon('plus-circle'),
      href: app.route('bsi.new')
    }, t('nav.new_order')));
    return m("div", {
      className: "BsiOrderList"
    }, m("div", {
      className: 'BsiOrderList-head' + (this.attrs.admin ? ' BsiOrderList-head--admin' : '')
    }, m("span", null, t('orders.order')), this.attrs.admin && m("span", null, t('orders.customer')), m("span", null, t('orders.vehicle')), m("span", null, t('orders.unit')), m("span", null, t('orders.status')), m("span", null, t('orders.price'))), orders.map(order => m(Link, {
      className: 'BsiOrderCard' + (this.attrs.admin ? ' BsiOrderCard--admin' : ''),
      href: orderUrl(order.id),
      key: order.id
    }, m("div", {
      className: "BsiOrderCard-number"
    }, m("strong", null, "#", order.id), m("small", null, date(order.created_at))), this.attrs.admin && m("span", {
      className: "BsiOrderCard-customer"
    }, order.user?.display_name || order.user?.username || '—'), m("span", {
      className: "BsiOrderCard-vehicle"
    }, vehicle(order)), m("span", {
      className: "BsiOrderCard-unit"
    }, [order.control_unit_type, order.control_unit_number].filter(Boolean).join(' / ') || '—'), m(Status, {
      status: order.status
    }), m("strong", {
      className: "BsiOrderCard-price"
    }, money(order.quoted_amount, order.quoted_currency)))));
  }
}
export class Pagination extends Component {
  view() {
    const {
      page,
      total,
      perPage,
      change,
      loading
    } = this.attrs;
    if (total <= perPage) return null;
    const pages = Math.ceil(total / perPage);
    return m("nav", {
      className: "BsiPagination",
      "aria-label": text('orders.pagination')
    }, m(Button, {
      className: "Button",
      icon: buttonIcon('caret-left'),
      "aria-label": text('orders.previous'),
      disabled: page <= 1 || loading,
      onclick: () => change(page - 1)
    }, t('orders.previous')), m("span", null, t('orders.page', {
      current: page,
      total: pages
    })), m(Button, {
      className: "Button",
      icon: buttonIcon('caret-right'),
      disabled: page >= pages || loading,
      onclick: () => change(page + 1)
    }, t('orders.next')));
  }
}
export class ConfirmModal extends Modal {
  className() {
    return 'BsiConfirmModal Modal--small';
  }
  title() {
    return this.attrs.title;
  }
  content() {
    return m("div", {
      className: "Modal-body"
    }, m("p", null, this.attrs.message), m(ErrorBox, {
      error: this.error
    }), m("div", {
      className: "BsiActions"
    }, m(Button, {
      className: "Button Button--primary",
      loading: this.loading,
      onclick: () => this.submit()
    }, this.attrs.confirm || t('common.confirm')), m(Button, {
      className: "Button",
      disabled: this.loading,
      onclick: () => this.hide()
    }, t('common.cancel'))));
  }
  submit() {
    this.loading = true;
    Promise.resolve(this.attrs.action()).then(() => this.hide()).catch(error => {
      this.error = error;
    }).finally(() => {
      this.loading = false;
      m.redraw();
    });
  }
}
export class BsiFooter extends Component {
  view() {
    return m("footer", {
      className: "BsiFooter"
    }, m("div", {
      className: "container"
    }, m("div", {
      className: "BsiFooter-main"
    }, m("div", {
      className: "BsiFooter-identity"
    }, m(Link, {
      className: "BsiFooter-brand",
      href: app.route('index')
    }, m("span", {
      className: "BsiBrandMark",
      "aria-hidden": "true"
    }), m("span", {
      className: "BsiWordmark"
    }, "BSI", m("span", null, ".by"))), m("small", null, t('home.unit_types'))), m("nav", {
      className: "BsiFooter-links",
      "aria-label": text('public.footer_navigation')
    }, Object.entries(pageIcons).map(_ref => {
      let [page, icon] = _ref;
      return m(Link, {
        href: app.route('bsi.' + page),
        key: page,
        "aria-current": app.current.get('routeName') === 'bsi.' + page ? 'page' : undefined
      }, m(BsiIcon, {
        name: icon
      }), m("span", null, t('public.' + page + '.title')));
    })))));
  }
}
export class FileField extends Component {
  onupdate() {
    if (!this.attrs.file && this.input?.value) this.input.value = '';
  }
  view() {
    const limit = app.forum.attribute('bsiMaxFileSize') || 33554432;
    const id = this.attrs.id || 'bsi-file';
    const file = this.attrs.file;
    return m("div", {
      className: "Form-group"
    }, m("label", {
      htmlFor: id
    }, this.attrs.label || t('form.file'), this.attrs.required && m("span", {
      "aria-hidden": "true"
    }, " *")), m("input", {
      className: "BsiFileInput BsiNativeFileInput",
      type: "file",
      id: id,
      name: "file",
      disabled: this.attrs.disabled,
      tabindex: "-1",
      "aria-required": !!this.attrs.required,
      "aria-describedby": id + '-limit',
      oncreate: vnode => this.input = vnode.dom,
      onchange: e => {
        const selected = e.target.files?.[0] || null;
        if (selected && selected.size > limit) {
          e.target.value = '';
          this.error = t('errors.file_too_large');
          this.attrs.onchange(null);
        } else {
          this.error = null;
          this.attrs.onchange(selected);
        }
      }
    }), m(Button, {
      className: "Button BsiFilePicker",
      type: "button",
      icon: buttonIcon('upload-simple'),
      disabled: this.attrs.disabled,
      onclick: () => this.input?.click()
    }, t(file ? 'files.replace' : 'files.choose')), file && m("div", {
      className: "BsiSelectedFile",
      "aria-live": "polite"
    }, m(BsiIcon, {
      name: "file-code"
    }), m("div", null, m("strong", null, file.name), m("small", null, fileSize(file.size)))), m("p", {
      className: "helpText",
      id: id + '-limit'
    }, t('files.limit', {
      size: Math.floor(limit / 1024 / 1024)
    })), this.attrs.uploading && m(UploadProgress, {
      percent: this.attrs.progress
    }), m(ErrorBox, {
      error: this.error
    }));
  }
}
export class UploadProgress extends Component {
  view() {
    const percent = this.attrs.percent;
    const label = percent === 100 ? t('files.saving') : percent == null ? t('files.uploading_unknown') : t('files.uploading', {
      percent
    });
    return m("div", {
      className: "BsiUploadProgress",
      role: "status",
      "aria-live": "polite"
    }, m("span", null, label), m("progress", {
      max: "100",
      value: percent == null ? undefined : percent,
      "aria-label": text('files.progress')
    }));
  }
}
flarum.reg.add('bsi-orders', 'forum/components/Shared', { MobileTitle: MobileTitle,Status: Status,ErrorBox: ErrorBox,PageHeading: PageHeading,AuthRequired: AuthRequired,OrderCards: OrderCards,Pagination: Pagination,ConfirmModal: ConfirmModal,BsiFooter: BsiFooter,FileField: FileField,UploadProgress: UploadProgress, });